module.exports = require('./lib/heap');



//////////////////
// WEBPACK FOOTER
// ./~/heap/index.js
// module id = 22
// module chunks = 0